import { render, staticRenderFns } from "./guidanceList.vue?vue&type=template&id=2081bd5b&scoped=true&"
import script from "./guidanceList.vue?vue&type=script&lang=js&"
export * from "./guidanceList.vue?vue&type=script&lang=js&"
import style0 from "./guidanceList.vue?vue&type=style&index=0&id=2081bd5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081bd5b",
  null
  
)

export default component.exports